<template>
    <footer class="footer-section pt-80px pb-80px position-relative overflow-hidden">
        <div class="container">
            <div class="row responsive-tablet-col-2 responsive-mobile-col-1">
                <div class="col-md-3">
                    <div class="footer-widget footer-widget-logo">
                        <router-link to="/" v-if="dlabData.footer.logo">
                            <img :src="dlabData.footer.logo" alt="Logo">
                        </router-link>
                        <p v-if="dlabData.footer.description">{{dlabData.footer.description}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <footer-links-widget :items="dlabData.footer.footerHelp" />
                </div>
                <div class="col-md-3">
                    <footer-links-widget :items="dlabData.footer.footerCompany" />
                </div>
                <div class="col-md-3">
                    <div class="footer-widget footer-social-links">
                        <h1>Contact With Us</h1>
                        <ul>
                            <li>
                                <a href="">
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'facebook-f']" /></span>
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'facebook-f']" /></span>
                                </a>
                            </li>
                            <li>
                                <a href="">
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'twitter']" /></span>
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'twitter']" /></span>
                                </a>
                            </li>
                            <li>
                                <a href="">
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></span>
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></span>
                                </a>
                            </li>
                            <li>
                                <a href="">
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'instagram']" /></span>
                                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'instagram']" /></span>
                                </a>
                            </li>
                        </ul>
                        <p class="copyright">
                            Copyright © 2022 <span>ThemeOnFair</span> Inc.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import dlabData from '@/store/store.js';
import FooterLinksWidget from '../pieces/FooterLinksWidget.vue'
export default {
    name: 'ThemeFooter',
    components: {
        FooterLinksWidget
    },
    data() {
        return {
            dlabData
        }
    }
}
</script>